<template>
  <MyManage>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="经营中心" name="business" v-if="checkPermission(['bee:order:businessCenter:businessCenterStatistic'])">
        <BusinessCenter v-if="activeName==='business'"></BusinessCenter>
      </el-tab-pane>
    </el-tabs>
  </MyManage>
</template>

<script>
  import MyManage from '@/components/MyManage'
  import BusinessCenter from '@/module/dataCenter/page/businessCenter/businessCenter2.vue'

  export default {
    name: 'manage',
    components: {
      MyManage,
      BusinessCenter
    },
    data() {
      return {
        activeName: 'business',
      }
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    methods: {
      handleClick(tab, event) {
      }
    }
  }
</script>

<style>
  .el-dialog__header {
    text-align: center;
  }

  #manage .el-switch.is-disabled .el-switch__core, #manage .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/businessManager.vue